import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Union } from '../models/union';
import { SubdomainService } from './subdomain.service';

@Injectable({
  providedIn: 'root',
})
export class UnionService {
  private baseURL = `${environment.apiBaseUrl}/api/union/`;
  constructor(
    private httpClient: HttpClient,
    private subdomainService: SubdomainService
  ) {}

  doLoad = async (
    paramObject?: any,
    location?: any
  ): Promise<Observable<any>> => {
    let queryParams: string;
    let url = `${this.baseURL}${location}`;
    if (paramObject) {
      queryParams = new URLSearchParams(paramObject).toString();
      url = `${url}?${queryParams}`;
    }
    return this.httpClient.get<any>(url);
  };

  doPost = (paramObject: any, body: any, location: string): Observable<any> => {
    let queryParams: string;
    let url = `${this.baseURL}${location}`;
    if (paramObject) {
      queryParams = new URLSearchParams(paramObject).toString();
      url = `${url}?${queryParams}`;
    }
    return this.httpClient.post<any>(url, body);
  };

  updateUnion = (union: Union): Observable<any> => {
    return this.doPost({}, union, 'update');
  };

  getSingleUnion = (): Observable<any> => {
    let body = {
      subdomain: this.subdomainService.getSubdomain(),
    };
    return this.httpClient.post<any>(`${this.baseURL}getSingle`, body);
  };

  // Get all unions (Super Admin only)
  getAllUnions = (params?: any): Observable<any> => {
    let queryParams: string;
    let url = `${this.baseURL}list`;
    if (params) {
      queryParams = new URLSearchParams(params).toString();
      url = `${url}?${queryParams}`;
    }
    return this.httpClient.get<any>(url);
  };

  // Toggle union status (Super Admin only)
  toggleUnionStatus = (statusData: any): Observable<any> => {
    return this.doPost({}, statusData, 'toggleStatus');
  };

  // Get union status history (Super Admin only)
  getUnionStatusHistory = (unionId: number, params?: any): Observable<any> => {
    let queryParams: string;
    let url = `${this.baseURL}${unionId}/history`;
    if (params) {
      queryParams = new URLSearchParams(params).toString();
      url = `${url}?${queryParams}`;
    }
    return this.httpClient.get<any>(url);
  };
}
